import React from 'react';
import { filter } from 'lodash';
import Select from 'react-select';
import { getText } from 'helpers/app/getText';
import { CUSTOMER_PRIVACY_NOTICE_URL } from 'configs/constants';

const Footer = (props) => {
  const { pageLanguages, defaultLanguage, onLanguageChange, moreInfoURL, onEndRental, privacyPolicyURL, customerAgreementURL, isQuickshopRentalSet } = props;

  const year = new Date().getFullYear();

  return (
    <footer className="text-muted-white mt-10" style={{ backgroundColor: '#393e46' }}>
      <div className="container text-center text-md-left">
        <div className="row footer-links">
          {moreInfoURL?.length > 0 && (
            <div className="col-md-3 mx-auto my-10">
              <a href={moreInfoURL} target="_blank" className="color-white">
                {getText('main:MORE_INFO')}
              </a>
            </div>
          )}
          {privacyPolicyURL?.length > 0 && (
            <div className="col-md-3 mx-auto my-10">
              <a href={privacyPolicyURL} target="_blank" className="color-white">
                {getText('main:PRIVACY_POLICY')}
              </a>
            </div>
          )}
          {customerAgreementURL?.length > 0 && (
            <div className="col-md-3 mx-auto my-10">
              <a href={customerAgreementURL} target="_blank" className="color-white">
                {getText('main:CUSTOMER_AGREEMENT')}
              </a>
            </div>
          )}
          {isQuickshopRentalSet && (
            <div className="col-md-3 mx-auto my-10 link-type text-center">
              <a onClick={() => onEndRental()} className="color-white">
                {getText('main:RENTAL')}
              </a>
            </div>
          )}
        </div>
        <div className="lang-select align-center">
          <Select
            menuPlacement="top"
            value={defaultLanguage?.length > 0 ? filter(pageLanguages, { value: defaultLanguage })[0] : ''}
            options={pageLanguages}
            onChange={onLanguageChange}
            getOptionLabel={(e) => (
              <div className="pos-status-icon-div">
                <img src={e.image} className="pos-status-icon mr-2" />
                <span style={{ marginLeft: 5 }}>{e.label}</span>
              </div>
            )}
          />
        </div>
        <div className="copyright align-center">
          <div className="d-flex justify-content-center flex-column flex-wrap">
            <span>&copy; Vourity AB {year}. All rights reserved.</span>
            <span>
              <a href={CUSTOMER_PRIVACY_NOTICE_URL} rel="noreferrer" className="footer-link" target="_blank">
                {getText('CUSTOMER_PRIVACY_NOTICE')}
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';

export default Footer;
